import { EntityBase } from "./entity-base.model";
import { Lookup } from "./lookup.model";
export class Parameters extends EntityBase {
  public Caption: string;
  public ParameterName: string;
  public ParameterKindId: number;
  public ParameterKindTitle: string;
  public ParameterKind: Lookup;
}
